@if (data(); as data) {
  <div class="bg-kz-layout-featured">
    <div class="border-bottom p-2">
      <div class="font-medium flex flex-row gap-1 items-center">
        {{ data.hotel?.hotelName }}
        <app-stars class="pb-1" [stars]="$safeNavigationMigration(data.hotel?.hotelClass)" />
      </div>
      <div class="text-secondary">{{ data.hotel?.cityName }}, {{ data.hotel?.districtName }}</div>
    </div>
    <div class="border-bottom p-2 flex flex-col gap-2" data-testid="cart-tour-flight">
      @let departure = data.flight?.departureSegments?.[0];
      @if (departure) {
        <div class="font-medium w-full">
          {{ departure.airlineName }}
        </div>
        <div class="text-xs font-medium">{{ 'Outbound flight' | translate }}</div>
        <app-flight-leg-list
          testIdPrefix="cart-tour-leg-out"
          [segments]="data.flight?.departureSegments"
          [isBlock]="$safeNavigationMigration(data.flight?.isBlock)"
        />
        @if (data.flight?.returnSegments?.length) {
          <div class="text-xs font-medium">{{ 'Return flight' | translate }}</div>
          <app-flight-leg-list
            testIdPrefix="cart-tour-leg-back"
            [segments]="data.flight?.returnSegments"
            [isBlock]="$safeNavigationMigration(data.flight?.isBlock)"
          />
        }
        @if (fareLine(); as line) {
          <div class="text-xs font-medium" data-testid="cart-tour-fare">
            {{ (line.kind === 'bundle' ? 'TOUR_CART_BUNDLE' : 'TOUR_CART_FARE') | translate: { name: line.name } }}
          </div>
        }
        @if (trip(); as trip) {
          <div class="text-xs" data-testid="cart-tour-trip">
            {{ 'Trip' | translate }} {{ trip.from | date: dateFormat }} — {{ trip.to | date: dateFormat }} ·
            {{ 'NIGHTS_COUNT' | translate: { value: trip.nights } }}
          </div>
        }
      }
    </div>
    <div class="details-list p-2">
      <div class="flex-wrap" data-testid="cart-tour-hotel-stay">
        <mat-icon svgIcon="fill-calendar" color="primary" />
        {{ data.hotel?.checkInDate | date: dateFormat }} — {{ data.hotel?.checkOutDate | date: dateFormat }}
        @if (stay(); as stay) {
          ({{ '{n} of {m} nights' | translate: { n: stay.hotelNights, m: stay.tripNights } }})
          @if (stay.start === 'EveningBefore') {
            <span
              class="rounded-2xl px-2 bg-kz-light-blue-300 text-xs"
              data-testid="cart-tour-evening-before"
              [title]="
                'Lands {date} - the room is booked from the evening before'
                  | translate: { date: (stay.landing | date: dateTimeFormat) }
              "
              >{{ 'Evening before' | translate }}</span
            >
          }
        } @else {
          ({{ 'NIGHTS_COUNT' | translate: { value: data.hotel?.nights } }})
        }
      </div>
      @if (data.hotel?.roomCategoryName) {
        <div>
          <mat-icon svgIcon="fill-bed" color="primary" />
          {{ data.hotel.roomCategoryName }},
          @if (data.hotel.placementTypeName) {
            {{ data.hotel.placementTypeName }}
          }
        </div>
      }
      @if (data.hotel?.mealPlan) {
        <div>
          <mat-icon svgIcon="fill-nutrition" color="primary" />
          {{ data.hotel.mealPlan }}
        </div>
      }
      @if (data.hotel?.adults) {
        <div>
          <mat-icon svgIcon="user" color="primary" />
          {{ 'ADULTS_COUNT' | translate: { value: data.hotel.adults } }}
        </div>
      }
      @if (data.hotel?.children) {
        <div>
          <mat-icon svgIcon="child" color="primary" />
          {{ 'CHILDREN_COUNT' | translate: { value: data.hotel.children } }}
          @if (data.hotel._extraParams?.ages) {
            (
            {{ data.hotel._extraParams.ages.join(', ') }}
            )
          }
        </div>
      }
    </div>
  </div>
  <div class="text-kz-primary font-bold w-full text-center mt-2 mb-3">
    {{ data.totalPrice | priceFormat: data.priceCurrency }}
  </div>
}
